import type { WebComponentsConfig } from './config.type';

export const defaultWebComponentsConfig: WebComponentsConfig = {
  ASSETS_BASE_PATH: '/assets/',

  openLink: (url: string, external = true) =>
    external ? window.open(url, '_blank', 'noopener,noreferrer') : (location.href = url),
};
export default defaultWebComponentsConfig;
